import SDIcon from '../../SDIcon'

const IconFlagIT = (props) => (
  <SDIcon title='Italy' defaultColorKey='contentPrimary' viewBox='0 0 24 24' {...props}>
    <rect x="3" y="6" width="18" height="12" rx="2" fill="#FFFFFF" />
    <rect x="3" y="6" width="6" height="12" rx="2" fill="#1F8A4C" />
    <rect x="15" y="6" width="6" height="12" rx="2" fill="#E22D2D" />
    <rect x="3" y="6" width="18" height="12" rx="2" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.35" />
  </SDIcon>
)

export default IconFlagIT
